import "./App.css";
import Login from "./auth/Login";
import ErrorPage from "./pages/ErrorPage";
import { Route, Routes } from "react-router-dom";
import Register from "./auth/Register";
import LandingPage from "./pages/landing/LandingPage";
import UserTypeSelection from "./auth/UserType";
import LoginPharm from "./auth/LoginPharm";
import RegisterPharm from "./auth/RegisterPharm";
import ForgotPassword from "./auth/ForgotPassword";
import ForgotPasswordPharm from "./auth/ForgotPasswordPharm";
import Shopping from "./pages/shop/Shopping";
import { lazy, Suspense } from "react";

// Dynamically import Dashboard and PharmDashboard
const Dashboard = lazy(() => import("./pages/Dashboard"));
const PharmDashboard = lazy(() => import("./pages/PharmDashboard"));

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {/* Unprotected Routes */}
        <Route path="/" element={<LandingPage />} />
        {/* Authentication Routes */}
        <Route path="/auth/register/buyer" element={<Register />} />
        <Route path="/auth/register/pharm" element={<RegisterPharm />} />
        <Route path="/auth/login/buyer" element={<Login />} />
        <Route path="/auth/login/pharm" element={<LoginPharm />} />
        <Route path="/auth/forgotpassword" element={<ForgotPassword />} />
        <Route
          path="/auth/forgotpassword/pharm"
          element={<ForgotPasswordPharm />}
        />
        <Route path="/shopnow" element={<Shopping />} />
        <Route path="/auth/select-user-type" element={<UserTypeSelection />} />

        {/* Dashboard Routes (Protected Routes) */}
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/pharmdashboard/*" element={<PharmDashboard />} />

        

        {/* Catch-All Route for Non-existent Pages */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Suspense>
  );
}

export default App;
